/**
 * Adds values together
 * @param values n amount of numbers
 * @returns Addition of values
 */
export function hbsHelperSum(...values: any): number {
  const filtered = values.filter(x => !isNaN(parseFloat(x)) && isFinite(x));
  return filtered.reduce((a: number, b: number) => a + b, 0);
}